var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0.933333H23.3333C25.3952 0.933333 27.0667 2.6048 27.0667 4.66667V23.3333C27.0667 25.3952 25.3952 27.0667 23.3333 27.0667H4.66667C2.6048 27.0667 0.933333 25.3952 0.933333 23.3333V4.66667C0.933333 2.6048 2.6048 0.933333 4.66667 0.933333Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58643 21.3928V25.0798L3.55709 27.0504H24.4948L26.8348 25.0798V20.6381C22.2806 15.0032 20.6862 14.8795 16.0898 18.2193C15.3677 18.744 14.8492 18.5159 14.3467 17.872L10.4532 12.8825C9.68227 11.8945 8.20468 11.8485 7.37506 12.7878C5.47336 14.9407 2.44296 20.4913 1.58643 21.3928Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6766 8.42596C22.6766 10.3305 21.1327 11.8745 19.2281 11.8745C17.3235 11.8745 15.7795 10.3305 15.7795 8.42596C15.7795 6.52138 17.3235 4.97742 19.2281 4.97742C21.1327 4.97742 22.6766 6.52138 22.6766 8.42596Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.01fe6385d9290af3e928f37505b0f8a6.svg";
export { ForwardRef as ReactComponent };